/*
 * @Author: Han
 * @Date: 2022-05-10 16:12:23
 * @LastEditors: Han
 * @LastEditTime: 2022-05-10 18:09:33
 * @FilePath: \czssj-h5\h5\src\libs\vant-use.js
 */
import Vue from 'vue'
import {
  Tabbar,
  TabbarItem,
  Overlay,
  Icon,
  ActionSheet,
  DropdownMenu,
  DropdownItem,
  Toast,
  ImagePreview,
  Dialog,
  List,
  Field,
  Button,
  Popup,
  Area,
  Picker
} from 'vant';
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Overlay);
Vue.use(Icon);
Vue.use(ActionSheet);
Vue.use(DropdownMenu);
Vue.use(Toast)
Vue.use(DropdownItem);
Vue.use(ImagePreview);
Vue.use(Dialog);
Vue.use(List);
Vue.use(Field);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Picker);



// WEBPACK FOOTER //
// ./src/libs/vant-use.js